import i18n from './i18n';

// Ensure language is properly initialized
const savedLang = localStorage.getItem('i18nextLng');
if (!savedLang) {
  localStorage.setItem('i18nextLng', 'en');
  i18n.changeLanguage('en');
} else {
  i18n.changeLanguage(savedLang);
}

// Set direction based on current language
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = i18n.language;

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  document.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  localStorage.setItem('i18nextLng', lng);
});

export default i18n; 